import React from 'react';
import PropTypes from 'prop-types';
import './Badge.css';

const Badge = ({ label, style }) => {
  return (
    <span className="badge" style={style}>{label}</span>
  );
};

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
};

export default Badge;